import { createStore } from 'vuex'

export default createStore({
  state: {
	  //取得token：先 sessionStorage（同 tab 内），降级到 localStorage（跨 tab/刷新）
	  tokenString: window.sessionStorage.getItem('token') || window.localStorage.getItem('token') || '',
	  uIdString: localStorage.getItem('uId') ? localStorage.getItem('uId') : ''
  },
  mutations: {
	  // 修改 token：同步写 session + local，避免刷新或新开 tab 丢失
	  changeLogin (state,token) {
	    state.tokenString = token.token;
	    window.sessionStorage.setItem('token', token.token);
	    window.localStorage.setItem('token', token.token);
	  }
  },
  getters:{
  	tokenString(state) {
  		return state.tokenString;
  	},
  
  	uIdString(state) {
  		return state.uIdString;
  	}
  },
  actions: {
  },
  modules: {
	 
  }
})